import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService} from '../_services';
import { ApiService } from '../_services/api.service';

@Component({templateUrl: 'verify.component.html'})
export class VerifyComponent implements OnInit {
    verificationId: string;
    isVerified= false;
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private apiService: ApiService,
        private alertService: AlertService) { 

            this.route.queryParams.subscribe(params => {
                this.verificationId = params['id']; 
                this.verificationId = this.trimChar(this.verificationId,'-');
                console.log(this.verificationId);
                if(this.verificationId){
                    apiService.verifyAccount(this.verificationId).subscribe(r=>
                        {
                            if(r){
                                //alertService.success("You have successfully verified your account - please log in using your email and chosen password");
                                this.isVerified = true;
                            }
                        },err=>{
                            alertService.error("Could not verify your account. Please contact support team.");
                        });
                }
            });
        }

    ngOnInit() {

    }

    trimChar(string: string, charToRemove: string) {
        while(string.charAt(0)==charToRemove) {
            string = string.substring(1);
        }
    
        while(string.charAt(string.length-1)==charToRemove) {
            string = string.substring(0,string.length-1);
        }
    
        return string;
    }

    verifyMember(){

    }


}



// WEBPACK FOOTER //
// ./src/app/verify/verify.component.ts